import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, ILocationService, IModule, IPromise, IScope} from "angular";
import {StateService} from "@uirouter/angularjs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker, Varighet} from "felles/tjenester/MeldingTilBruker";
import {fraJson} from "felles/stoettefunk/json";
import {PlanRessurs} from "felles/tjenester/ressurser/PlanRessurs";
import {escKey_event} from "web/direktiver/escKey";
import {Datointerval} from "felles/stoettefunk/dato/Datointerval";
import {Debugger} from "debug";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {tilLokalDatoIgnorerTs} from "../../../../../felles/tjenester/Datoer";
import {DatoPerioder} from "felles/stoettefunk/datoPerioder";
import {erNill} from "felles/stoettefunk/nillsjekk";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

require('./dashboardFilter.scss');

const debug: Debugger = require('debug')('DashboardFilterKontroller');

export class DashboardFilterKontroller implements IController {
    static eventer = {
        visFilter: "DashboardFilterKontroller.visFilter",
        visForrigePeriode: "DashboardFilterKontroller.visForrigePeriode",
        visNestePeriode: "DashboardFilterKontroller.visNestePeriode",
        visInnværendePeriode: "DashboardFilterKontroller.visInnværendePeriode"
    };

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmDashboardFilter', {
                bindings: {vedFilterEndret: '&', vedFilterEkspandert: '&'},
                controller: DashboardFilterKontroller.forInjisering(),
                template: require('./dashboardFilter.html')
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$location,
            regNavn.ng.ui.$state,
            PlanRessurs.regNavn,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            DashboardFilterKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $location: ILocationService,
                private $state: StateService,
                private planRessurs: PlanRessurs,
                private navigasjon: WebNavigasjon,
                private kontekst: Kontekst,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog) {
        this.lyttTilBrukerRelastetEvent();
    }

    vedFilterEndret: (args: { filter: DashboardFiltervalg }) => IPromise<void>; //satt via bindings
    vedFilterEkspandert: (args: { ekspandert: boolean }) => void; //satt via bindings

    modell: {
        grupper: { gruppe: l.EnkelGruppeModell; valgt: boolean }[];
        ingenGrupperValgt: boolean;
        alleGrupperValgt: boolean;
        valgtPeriode: Periode;
        tilgjengeligPerioder: Periode[];

        spesifikasjon: DashboardFiltervalg;
    };

    viserFilterSkjema = false;

    sisteSpesifikasjon: DashboardFiltervalg;

    /// tittel på submit-knapp dashboard filterskjema
    stdSoekKnappTekst = this.gettextCatalog.getString('Vis møter');
    soekKnappTekst = this.stdSoekKnappTekst;

    filterbeskrivelse = "";

    private visFilterLytterAvregistrering;

    toggleFilterSkjema() {
        this.setFilterSkjemaVises(!this.viserFilterSkjema);
    }

    togleAlleGrupper(){
        const endreTilValgt = !this.modell.alleGrupperValgt;
        this.modell.grupper.forEach(g => g.valgt = endreTilValgt);
        this.oppdaterAlleIngenGrupperValgtFlagg();
        this.oppdaterAggregater();
    }

    oppdaterAlleIngenGrupperValgtFlagg(){
        this.modell.alleGrupperValgt = this.modell.grupper.every(g => g.valgt);
        this.modell.ingenGrupperValgt = this.modell.grupper.every(g => !g.valgt);
    }

    gruppeValgEndret(){
        this.oppdaterAlleIngenGrupperValgtFlagg();
        this.oppdaterAggregater();
    }

    oppdaterAggregater() {
        this.soekKnappTekst = this.sisteSpesifikasjon != null && this.spesifikasjonEndretSidenSisteSoek() ?
            /// tittel på submit-knapp dashboard filterskjema når skjema har blitt endret
            this.gettextCatalog.getString("Oppdater møtevisning") : this.stdSoekKnappTekst;
    }

    anvendFilter() {
        /// tittel på submit-knapp dashboard filterskjema mens submit behandles
        this.soekKnappTekst = this.gettextCatalog.getString("Oppdaterer møtevisning...");
        this.sisteSpesifikasjon = _.clone(this.spesifikasjon());

        this.vedFilterEndret({filter: this.sisteSpesifikasjon})
            .then(() => this.soekKnappTekst = this.stdSoekKnappTekst);

        //sørg for at søket blir reflektert i url og dermed legger seg inn i nav-historikk
        this.persisterSpesifikasjon();

        const antallValgt = this.modell.grupper.filter(gruppe => gruppe.valgt).length;
        if (antallValgt == this.modell.grupper.length)
            /// beskrivelse av filter på dashboardsiden som vises når filter ikke er ekspandert, når alle grupper er valgt
            this.filterbeskrivelse = this.gettextCatalog.getString('Viser møter for alle grupper, {{periode}}', {
                periode: this.modell.valgtPeriode.tittel
            });

        else if (antallValgt > 6)
            /// beskrivelse av filter på dashboardsiden som vises når filter ikke er ekspandert, når et subsett (> 6) av tilgjengelige grupper er valgt
            this.filterbeskrivelse = this.gettextCatalog.getString('Viser møter for {{antallValgt}} av {{totaltAntall}} grupper, {{periode}}', {
                periode: this.modell.valgtPeriode.tittel,
                antallValgt: antallValgt,
                totaltAntall: this.modell.grupper.length
            });

        else
            /// beskrivelse av filter på dashboardsiden som vises når filter ikke er ekspandert, når et subsett av tilgjengelige grupper er valgt
            this.filterbeskrivelse = this.gettextCatalog.getString('Viser møter for {{grupper}}, {{periode}}', {
                periode: this.modell.valgtPeriode.tittel,
                grupper: this.valgteGrupper().map(gruppe => `${gruppe.organisasjonsnavn} (${gruppe.tittel})`).join(', ')
            });
    }

    spesifikasjonEndretSidenSisteSoek() {
        /*
         * AI analyse av stacktrace:
         * Found the root cause. The template uses spesifikasjonEndretSidenSisteSoek() in an ng-class binding, which gets evaluated during every $digest cycle — including before initialiserModell() completes.
         * At that point valgtPeriode is null (line 268), so spesifikasjon() crashes on line 341 reading .start.
         * The fix is to guard against null valgtPeriode in spesifikasjonEndretSidenSisteSoek.
         */
        if (!this.modell.valgtPeriode) return false;
        return !_.isEqual(this.sisteSpesifikasjon, this.spesifikasjon());
    }

    $onInit(): void {
        this.lyttTilPeriodeValgEventer();
        this.lyttTilEscKeypress();
        this.lyttVisFilter();
        this.initialiserModell()
            .then(() => {
                this.anvendFilter();
                this.oppdaterAlleIngenGrupperValgtFlagg();
                this.oppdaterAggregater();
            });
    }

    $onDestroy(): void {
        this.visFilterLytterAvregistrering();
    }

    static serialisertDashboardFiltervalg(spesifikasjon:DashboardFiltervalg):string{
        debug('serialisertDashboardFiltervalg %O',spesifikasjon,  _.defaults({}, spesifikasjon))

        const tilSerialisering = {...spesifikasjon};
        //fjern periode-informasjon dersom vi ser på plan for inneværende år - dette for at ikke periode skal
        //bli inkludert i URL og følgelig etter hvert alltid ta bruker til 'feil' årsplan
        if (erIkkeNil(tilSerialisering.periode) && DatoPerioder.inneholderNå(tilSerialisering.periode)) tilSerialisering.periode = null;

        return angular.toJson(tilSerialisering);
    }

    static periodeTittel(periode: {start:Date; slutt:Date}){
        const år = _.toString(periode.start.getUTCFullYear())
        //planer MÅ ikke nødvendigvis spenne over et helt år - i tilfeller der planer ikke spenner over hele år inkluderer vi månedsnavnet i tittel
        if ( Datointerval.fraPeriode(periode).antallMåneder() < 10){
            const mndStart = moment(tilLokalDatoIgnorerTs(periode.start)).format('MMM');
            const mndSlutt = moment(tilLokalDatoIgnorerTs(periode.slutt)).format('MMM');
            return `${år} (${mndStart} - ${mndSlutt})`;
        }
        return år;
    }

    // hjelpemetoder

    private lyttVisFilter() {
        this.visFilterLytterAvregistrering = this.$scope.$root.$on(DashboardFilterKontroller.eventer.visFilter, () => this.setFilterSkjemaVises(true));
    }

    private lyttTilEscKeypress() {
        this.$scope.$on(escKey_event, () => this.setFilterSkjemaVises(false));
    }

    private lyttTilPeriodeValgEventer() {
        this.$scope.$on(DashboardFilterKontroller.eventer.visForrigePeriode, () => this.endreAktivPeriode(-1));
        this.$scope.$on(DashboardFilterKontroller.eventer.visNestePeriode, () => this.endreAktivPeriode(+1));
        this.$scope.$on(DashboardFilterKontroller.eventer.visInnværendePeriode, () => this.gåTilInneværendePlan());
    }

    private endreAktivPeriode(offset: number) {
        let nyPeriodeIndeks = this.modell.tilgjengeligPerioder.indexOf(this.modell.valgtPeriode) + offset;
        if (nyPeriodeIndeks < 0) {
            /// når bruker klikker på forrige plan i dashboard og det ikke finnes noen tidligere plan
            this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Det finnes ingen tidligere planer"), Varighet.timeout_eller_navigasjon);
            return;
        }
        if (nyPeriodeIndeks >= this.modell.tilgjengeligPerioder.length) {
            /// når bruker klikker på neste plan i dashboard og det ikke finnes noen senere plan
            this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Det finnes ingen senere planer, klikk her for å opprette ny plan"), Varighet.sideskift, () => this.gåTilOpprettPlan());
            return;
        }
        this.modell.valgtPeriode = this.modell.tilgjengeligPerioder[nyPeriodeIndeks];
        this.anvendFilter();
    }

    private gåTilInneværendePlan(){
        const inneværendePeriode = this.modell.tilgjengeligPerioder.find(periode => DatoPerioder.inneholderNå(periode))
        if (erNill(inneværendePeriode)) {
            this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Det finnes ingen plan for {{aar}}, klikk her for å opprette ny plan", {aar: new Date().getFullYear()}), Varighet.sideskift, () => this.gåTilOpprettPlan());
            return;
        }
        this.modell.valgtPeriode = inneværendePeriode;
        this.anvendFilter();
    }

    private gåTilOpprettPlan(){
        const valgteGrupperIdr = this.valgteGrupperIdr();
        this.navigasjon.gåTilOpprettPlan(valgteGrupperIdr.length == 1 ? valgteGrupperIdr[0] : null);
        return true;
    }

    private setFilterSkjemaVises(vises: boolean) {
        this.viserFilterSkjema = vises;
        this.vedFilterEkspandert({ekspandert: vises});
    }

    private persisterSpesifikasjon() {
        debug('persisterSpesifikasjon');
        let spesifikasjon = this.spesifikasjon();
        this.$location.replace(); //for å unngå at vi legger til et nytt element i navigasjonshistorikken
        this.$location.search("q", DashboardFilterKontroller.serialisertDashboardFiltervalg(spesifikasjon));
        this.kontekst.oppdaterBrukervalg({dashboardfilter: spesifikasjon});
    }

    private lesPersistertSpesifikasjon(): DashboardFiltervalg {
        let lagretFilter: DashboardFiltervalg = fraJson(this.$state.params["q"]);
        if (!_.isObject(lagretFilter))
            lagretFilter = _.cloneDeep(this.kontekst.brukervalg().dashboardfilter);

        return <DashboardFiltervalg>_.defaults(lagretFilter, new DashboardFiltervalg());
    }

    private initialiserModell(): IPromise<void> {
        var filter = this.lesPersistertSpesifikasjon();
        this.modell = {
            tilgjengeligPerioder: [], //init via initialiserPerioder()
            valgtPeriode: null, //init via initialiserPerioder()
            grupper: _(this.kontekst.autentiserteGrupper())
                .map(gruppe => ({
                    gruppe: gruppe,
                    valgt: _.isEmpty(filter.gruppeIder) || _(filter.gruppeIder).includes(gruppe.id)
                }))
                .value(),
            alleGrupperValgt: false,
            ingenGrupperValgt: false,
            spesifikasjon: filter
        };
        return this.initialiserPerioder(filter);
    }

    private initialiserPerioder(filter: DashboardFiltervalg): IPromise<void> {
        debug("initialiserPerioder")
        return this.planRessurs.hentAlleForGrupper(this.modell.grupper.map(gruppe => gruppe.gruppe.id)).$promise
          .then(planer => {
              //for hver plan - lag et interval som dekker hele året - i utc-tid
              this.modell.tilgjengeligPerioder = _(planer)
                  .map(plan => plan.periode.start.getUTCFullYear())
                  .sort()
                  .uniq()
                  .map(år => Datointerval.årUTC(år))
                  .map(interval => (<Periode>{
                      tittel: _.toString(interval.start.getUTCFullYear()),
                      ...interval
                  }))
                  .value();

                /* dette er et tidligere forsøk på "smart" reduksjon til unike perioder - men den ble ikke korrekt..
                //det kan forekomme planer som ikke spenner over hele år (feks halvårsplaner)
                //reduser settet av planer til ikke-overlappende perioder
                this.modell.tilgjengeligPerioder = _(planer)
                    .sortBy(plan => plan.periode.start.getTime())
                    .reduce((unikePerioder, plan) => {
                        let aktivPeriode = _.last(unikePerioder);
                        if (overlappendePeriode(aktivPeriode, plan.periode)) {
                            aktivPeriode.start = minsteIkkeNullDato(aktivPeriode.start, plan.periode.start);
                            aktivPeriode.slutt = størsteIkkeNullDato(aktivPeriode.slutt, plan.periode.slutt);
                        } else {
                            //slutten på periode funnet
                            aktivPeriode = {...plan.periode, tittel: '', planer: []};
                            unikePerioder.push(aktivPeriode);
                        }
                        aktivPeriode.planer.push(plan);
                        aktivPeriode.tittel = DashboardFilterKontroller.periodeTittel(aktivPeriode);
                        return unikePerioder;
                    }, [{start: null, slutt: null, tittel: null, planer: []}]);*/
                debug("redusert til unike perioder", planer, this.modell.tilgjengeligPerioder)

                //periode er valgt i filter-gui - finn matchende planperiode, prøver først på lik startdato, så lik sluttdato, så siste planperiode, og til slutt inneværende år som fallback
                if (filter.periode)
                    this.modell.valgtPeriode = _(this.modell.tilgjengeligPerioder).find(periode => moment(periode.start).isSame(filter.periode.start));
                if (!this.modell.valgtPeriode)
                    this.modell.valgtPeriode = _(this.modell.tilgjengeligPerioder).find(periode => moment(periode.slutt).isAfter());
                if (!this.modell.valgtPeriode)
                    this.modell.valgtPeriode = _(this.modell.tilgjengeligPerioder).last();
                if (!this.modell.valgtPeriode) {
                    //ingen planer eksisterer for tilgjengelige grupper - bruk inneværende år som standard
                    const d = Datointerval.inneværendeÅrUTC();
                    this.modell.valgtPeriode = {
                        tittel: DashboardFilterKontroller.periodeTittel(d),
                        start: d.start,
                        slutt: d.slutt,
                        planer: []
                    }
                }
            });
    }

    private spesifikasjon(): DashboardFiltervalg {
        this.modell.spesifikasjon.gruppeIder = this.valgteGrupperIdr();
        this.modell.spesifikasjon.periode = {start: this.modell.valgtPeriode.start, slutt: this.modell.valgtPeriode.slutt};

        return this.modell.spesifikasjon;
    }

    private valgteGrupper(){
        return this.modell.grupper.filter(gruppe => gruppe.valgt).map(gruppe => gruppe.gruppe);
    }

    private valgteGrupperIdr(){
        return this.valgteGrupper().map(gruppe => gruppe.id);
    }

    private lyttTilBrukerRelastetEvent() {
        this.$scope.$on(Kontekst.brukerRelastetEvent, () => {
            this.initialiserModell();
        });
    }
}

interface Periode {
    tittel: string;
    start: Date;
    slutt: Date;
    /** liste med planene denne perioden omfatter */
    planer: l.EnkelPlanModell[];
}

export class DashboardFiltervalg implements l.DashboardFiltervalg {
    /** gruppeIder for valgte grupper */
    gruppeIder = [];
    periode = null;

    gruppering = l.SaksgrupperingPlan.tema;
    visningsvalg: 'saksnummer' | 'saksnavn' = 'saksnummer';
    visSaksdetaljer = true;
    visAarshjulinnslag = true;
}

